import { useEffect } from "react";

const SUPPORT_URL = "https://sites.google.com/view/nfp-support/home";

export default function Support() {
  useEffect(() => {
    window.location.replace(SUPPORT_URL);
  }, []);

  return (
    <div
      className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-6 text-center"
      data-testid="page-support"
    >
      <div>
        <p className="text-[11px] tracking-[0.3em] uppercase text-[#1FA2FF]">Redirecting</p>
        <h1 className="nfp-heading text-3xl mt-3">NFP Support</h1>
        <p className="mt-3 text-white/60 max-w-md mx-auto">
          You are being redirected to the NFP Support Center. If your browser
          doesn't redirect,{" "}
          <a href={SUPPORT_URL} className="text-[#00E5FF] hover:underline">
            click here
          </a>
          .
        </p>
        <p className="mt-6 text-white/50 text-sm">
          Or email us at{" "}
          <a href="mailto:Tray@nofatiguetraining.net" className="text-[#00E5FF] hover:underline">
            Tray@nofatiguetraining.net
          </a>
        </p>
      </div>
    </div>
  );
}
